import { createContext } from 'react';
var context = {
  fabrics: null,
  gender: null,
  setGender: null
};
export var CollectionContext = /*#__PURE__*/createContext(context);